var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal-binnacle",
      attrs: {
        id: "modal-binnacle-" + _vm.actualId,
        title: _vm.title,
        "no-close-on-backdrop": "",
        size: "md",
        "hide-footer": ""
      }
    },
    [
      _c("BinnacleList", {
        ref: "list-binnacle",
        attrs: { id: "list-binnacle-" + _vm.actualId }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }